import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid, TextField } from "react-admin";

import { DatagridWithBlockDeleteProps } from "../../../components/_helpers/props/DatagridProps";
import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { ExternalTerminalLinkFilter } from "./ListFilters";
import { SelectEnumField } from "components/fields/SelectEnumField";
import { ExternalTerminalConnectionStatus } from "entities/ExternalTerminalConnectionStatus";
import { ConnectionActionButton } from "./Actions/ConnectButton";
import { ExternalTerminalLinkActions } from "./Actions/ListActions";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import { TERMINAL_DEFAULT_VALUE } from "components/filters/ToggleTerminalsFilter";


const defaultSort = { field: "external_name", order: "ASC" };
const defaultFilter = { "always_sync": true };


export const ExternalTerminalLinkList = (props) => {
	const classes = stylesForColorInheritInList();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const { data: terminalsData = {} } = useTerminalsContext();

	const terminalId = globalFilters?.terminal_id ? 
		globalFilters.terminal_id[0] : TERMINAL_DEFAULT_VALUE;

	const currentFilters = {
		...defaultFilter, 
		...globalFilters, 
		own_terminal_guid: [terminalsData?.[terminalId]?.guid],
	};
	delete currentFilters?.["terminal_id"]

	if (Object.values(terminalsData).length === 0) return null;

	const rowStyle = (record) => {
		if (record.status === ExternalTerminalConnectionStatus.connected) {
			return { backgroundColor: "#B7FF7D" };
		} else if (record.status === ExternalTerminalConnectionStatus.requested) {
			return { backgroundColor: "#FFFF00" };
		} else if (record.status === ExternalTerminalConnectionStatus.refused) {
			return { backgroundColor: "#FF0000" };
		};
	};

	return (
		<AppList
			{...props}
			sort={defaultSort}
			filter={currentFilters}
			filterDefaultValues={currentFilters}
			empty={false}
			exporter={false}
			bulkActionButtons={false}
			filters={<ExternalTerminalLinkFilter />}
			actions={<ExternalTerminalLinkActions />}
			classes={classes}
		>
			<ScrollingWrapper>
				<Datagrid {...DatagridWithBlockDeleteProps} rowStyle={rowStyle}>
					<TextField source="own_terminal_name" />
					<TextField source="external_name" />
					<TextField source="external_owner_username" />
					<TextField source="external_address" />
					<TextField source="external_time_zone" />
					<SelectEnumField 
						source="status" 
						enumName="external_terminal_status" 
						enumObj={ExternalTerminalConnectionStatus} 
					/>
					<ConnectionActionButton />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
